import { ImageBlockConfigurationRecord } from "models/view-models/block-configurations/image-block-configuration-record";
import FileRecord from "models/view-models/file-record";
import React, { useMemo, useState } from "react";
import { PageBlockContentProps } from "../page-block-content";
import { useImageFilePath } from "molecules/page-block-content/image-block/use-image-file-path";
import { useSharedPageContext } from "utilities/contexts/shared-page/shared-page-context";
import ImageBlockImageDisplay from "molecules/page-block-content/image-block/image-block-image-display";
import { RecordUtils } from "@rsm-hcd/javascript-core";

interface ImageBlockContentProps extends PageBlockContentProps {}

const CSS_CLASS_NAME = "c-image-block-content";

const ImageBlockContent = ({ block, printable }: ImageBlockContentProps) => {
    const { pageGuid, recipientGuid } = useSharedPageContext();
    const [imageFile, setImageFile] = useState<FileRecord>();

    const imageFilePath = useImageFilePath(imageFile, pageGuid, recipientGuid);

    const imageBlockConfiguration = useMemo(() => {
        const configuration = RecordUtils.ensureRecord(
            block.configuration,
            ImageBlockConfigurationRecord
        );

        setImageFile(configuration.imageFile ?? undefined);

        return configuration;
    }, [block.configuration]);

    // -----------------------------------------------------------------------------------------
    // #region TEMPORARY
    // -----------------------------------------------------------------------------------------

    return (
        <div className={CSS_CLASS_NAME}>
            {imageFile ? (
                <ImageBlockImageDisplay
                    isEditable={false}
                    imageFilePath={imageFilePath}
                    size={imageBlockConfiguration.size}
                    position={imageBlockConfiguration.position}
                    imageAnnotations={imageBlockConfiguration.annotations}
                    printable={printable}
                />
            ) : (
                <div className={`${CSS_CLASS_NAME}__no_image`}>
                    Click to upload image
                </div>
            )}
        </div>
    );
};

export default ImageBlockContent;
